/**
 * External dependencies.
 */
import { has, isEmpty } from 'lodash';

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks';

/**
 * Internal dependencies.
 */
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

function styling( props, selector = false ) {
	const { blockAdvanceOptions } = props.attributes;
	let css = '';
	selector = selector ? selector : `.gutenify-section-${ props.clientId } .gutenify-star-rating-filled, .gutenify-section-${ props.clientId } .gutenify-star-rating-half`;
	let styleNormal = '';
	styleNormal += `${ has( blockAdvanceOptions, 'textColor' ) && ! isEmpty( blockAdvanceOptions.textColor ) ? `color: ${ blockAdvanceOptions.textColor };` : '' }`;

	if ( styleNormal ) {
		css += `${ selector } { ${ styleNormal } }`;
	}
	return applyFilters( `gutenify--${ hookPrefix }--inline-styles`, css, props );
}
export default styling;

